// Stable per-browser device id, kept in localStorage. We reuse the legacy
// `gnpf-device-id` key so users who already enrolled under the HS256 flow
// keep the same fingerprint when they re-enroll in authv2.
const STORAGE_KEY = "gnpf-device-id";

export function getFingerprint(): string {
  let id = localStorage.getItem(STORAGE_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
  }
  return id;
}

// Same id, but never throws: private windows and blocked site data make
// localStorage throw, and a check-in must not fail because of a fraud-trace
// stamp (QĐ 0376). Empty string = "no device id", the server falls back to
// the older user-agent + IP trace.
export function tryGetFingerprint(): string {
  try {
    return getFingerprint();
  } catch {
    return "";
  }
}

// Best-effort human-readable label for the auth_device row. Worth showing
// the user in the device-management UI ("Chrome • MacIntel") but not a
// security boundary.
export function getDeviceLabel(): string {
  const ua = navigator.userAgent;
  const browser =
    /Chrome\//.test(ua) ? "Chrome" :
    /Firefox\//.test(ua) ? "Firefox" :
    /Safari\//.test(ua) ? "Safari" :
    /Edg\//.test(ua) ? "Edge" : "Browser";
  const platform = navigator.platform || "Unknown";
  return `${browser} • ${platform}`;
}
